import React, { useEffect, useState } from "react";
import cookie from "cookiejs";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { theme } from "../../common/Theme/theme";
import i18next from "i18next";
import { gsap } from "gsap";

const Root = styled("div")({
  overflow: "scroll",
  overflowX: "hidden",
  backgroundImage: `url(${require("../../assets/images/slide/fondo-grafito.jpg")})`,
  backgroundColor: "#000000",
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  zIndex: 9999,
});
const Container = styled("div")({
  position: "relative",
  width: "100%",
  height: "100%",
});
const Content = styled("div")({
  position: "relative",
  zIndex: 10,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});
const ContainerButtonLink = styled("div")({
  display: "flex",
});
const ButtonLink = styled("div")({
  display: "flex",
  flexDirection: "column",
  border: "2px solid #d59570",
  color: "#ffffff",
  fontSize: "15px",
  fontFamily: "Rel-Regular",
  letterSpacing: 0.4,
  lineHeight: "20px",
  padding: "10px 20px",
  textTransform: "uppercase",
  alignItems: "stretch",
  margin: "0 15px",
  marginBottom: "clamp(18px,2vw,27px)",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 1s ease 0s",
  "&:hover": {
    backgroundColor: "#d59570",
    color: "#000000",
  },
});
const Text = styled(Typography)({
  fontFamily: "Rel-Regular",
  color: "#a1a1a1",
  textAlign: "center",
  fontSize: "15px",
  lineHeight: "clamp(28px,2.5vw,34px)",
  letterSpacing: 1.08,
  marginBottom: "clamp(32px,3.3vw ,45px)",
  "& span": {
    fontFamily: "Dis-Italic",
  },
});
const Logo = styled("img")({
  position: "relative",
  marginBottom: "clamp(40px,6vw,80px)",
  width: "clamp(102px,10.4vw,142px)",
});

const DivContent = styled("div")({
  margin: "auto",
  padding: "0 30px",
  position: "relative",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  [theme.breakpoints.up("md")]: {
    height: "auto",
  },
});
const ContainText = styled("div")({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  top: "auto",
});

const Legal = () => {
  const [refCuadro, setRefCuadro] = useState(null);
  const [refRoot, setRefRoot] = useState(null);
  const [legal, setLegal] = useState(false);
  useEffect(() => {
    showLegacy();
  }, []);
  const showLegacy = () => {
    let legacy = cookie.get("legalMascota");
    if (Boolean(legacy === "true")) {
      setLegal(false);
      return;
    } else {
      setLegal(true);
    }
  };
  const onClickAceptLegal = () => {
    setTimeout(() => {
      setLegal(false);
    }, 1000);

    cookie.set("legalMascota", "true", { expires: 0.01 });
    animation();
  };
  async function handleClick(lang) {
    i18next.changeLanguage(lang);
  }
  const animation = () => {
    let timeLine = gsap.timeline({});
    timeLine.to([refCuadro], {
      ease: "circ.inOut",
      duration: 0.6,
      opacity: 0,
    });
    timeLine.to([refRoot], {
      ease: "circ.inOut",
      duration: 1,
      opacity: 0,
      zIndex: -1,
    });
  };
  return (
    <React.Fragment>
      {legal ? (
        <Root ref={setRefRoot}>
          <Container>
            <Content ref={setRefCuadro}>
              <DivContent>
                <Logo
                  src={require("../../assets/images/legales/logo_mascota.png")}
                  alt="logo"
                />
                <ContainText>
                  <Text>
                    Al entrar a este sitio acepta que usted posee la edad legal
                    para beber en su país. <br />
                    <span>
                      When you enter this site you agree that you have the legal
                      drinking age in your country
                    </span>
                  </Text>
                  <ContainerButtonLink>
                    <ButtonLink
                      style={{ justifyContent: "center" }}
                      onClick={() => {
                        handleClick("esv2");
                        onClickAceptLegal();
                      }}
                    >
                      Español
                    </ButtonLink>
                    <ButtonLink
                      style={{ justifyContent: "center" }}
                      onClick={() => {
                        handleClick("env2");
                        onClickAceptLegal();
                      }}
                    >
                      English
                    </ButtonLink>
                  </ContainerButtonLink>
                </ContainText>
              </DivContent>
            </Content>
          </Container>
        </Root>
      ) : (
        <React.Fragment></React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Legal;
